import blogsData from "../blogsData.json";
import Li from "../common/li";
import Anchor from "../common/a";
import Time from "../common/time";



function Blogs() {
  return (
    <div>
      <p className="blog-title">Blog Posts</p>
      <ul>
        <li className="blog-list">
          <time dateTime="Thu, Jul 16 2020">Thu, Jul 16 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/07/16/zeroshell-a-linux-distibution-for-network-management/"
          >
            Découverte de Zeroshell OS
          </a>
        </li>
        <li className="blog-list">
          <time
            dateTime="Sat, Aug 01 2020
"
          >
            Sat, Aug 01 2020
          </time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/08/01/omochikaeri-le-uber-eat-opensource/"
          >
            OwnPlate le Uber Eat opensource.
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Wed, Aug 12 2020">Wed, Aug 12 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/08/12/git-tips-part2/"
          >
            Git Tips Part 2
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Jun 06 2020">Sat, Jun 06 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/06/06/sprint-conception-at-hostinger/"
          >
            Conception Sprints chez Hostinger
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Jun 06 2020">Sat, Jun 06 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/06/06/conception-sprints-chez-hostinger/"
          >
            Conception Sprints chez Hostinger
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Fri, Jun 12 2020">Fri, Jun 12 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/07/16/zeroshell-a-linux-distibution-for-network-management/"
          >
            Coup de projecteur sur l'initative ‘ED Africa Maker’
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Tue, Jun 02 2020">Tue, Jun 02 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/06/02/instalation-de-archlinux-sur-rapsberry-pi-3b/"
          >
            Instalation de Archlinux sur Rapsberry Pi 3B
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Tue, May 12 2020">Tue, May 12 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/05/12/watch-8000-iptv-channels-on-your-favorite-video-player-en/"
          >
            Watch +8000 IPTV Channels on your favorite Video Player
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Tue, May 12 2020">Tue, May 12 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/05/12/regardez-plus-de-8000-chaines-tele-dans-votre-lecteur-video/"
          >
            Regardez plus de 8000 chaines Télé dans votre lecteur video Favorite
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Thu, Mar 12 2020">Thu, Mar 12 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/03/12/impact-du-covid19-sur-economie-africaine/"
          >
            Impact du Covid19 sur l'economie Africaine
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Tue, Jan 28 2020">Tue, Jan 28 2020</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2020/01/28/whats-the-most-beautiful-website-world/"
          >
            What's the most beautiful website in the world
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Wed, May 22 2019">Wed, May 22 2019</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2019/05/22/promote-your-next-startup/"
          >
            Security Tips on startups Environement
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Fri, Feb 15 2019">Fri, Feb 15 2019</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2019/02/15/pourquoi-confier-son-site-a-une-agence-digitale/"
          >
            Voilà pourquoi confier votre site à une Agence Digital!
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Fri, Feb 15 2019">Fri, Feb 15 2019</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2019/02/15/comment-bien-rediger-son-cahier-des-charges/"
          >
            Savoir bien rédiger son cahier des charges!
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Wed, Feb 06 2019">Wed, Feb 06 2019</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2019/02/06/php-generators-cheatsheet/"
          >
            PHP Generators cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Jan 05 2019">Sat, Jan 05 2019</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2019/01/05/cest-quoi-un-api/"
          >
            Qu'est-ce qu'une api?
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Dec 02 2018">Sun, Dec 02 2018</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2018/12/02/ml-cheatsheet/"
          >
            Machine Learning cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Dec 02 2018">Sun, Dec 02 2018</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2018/12/02/vim-cheatsheet/"
          >
            Vim cheat sheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Jun 02 2018">Sat, Jun 02 2018</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2018/06/02/phpdoc-cheatsheet/"
          >
            Phpdoc cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Mon, Feb 12 2018">Mon, Feb 12 2018</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2018/02/12/promote-your-next-startup-date/"
          >
            Promote your next startup
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Dec 30 2017">Sat, Dec 30 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/12/30/people-in-cuba-built-their-own-internet/"
          >
            People in Cuba built their own Internet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Nov 18 2017">Sat, Nov 18 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/11/18/why-i-switched-my-iphone-in-distraction-free-mode/"
          >
            Why I Switched my iPhone in Distraction Free mode
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Mar 12 2017">Sun, Mar 12 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/03/12/git-tips/"
          >
            Git Tips
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Feb 12 2017">Sun, Feb 12 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/02/12/promote-your-opensource-project/"
          >
            Promote your opensource project
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Feb 12 2017">Sun, Feb 12 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/02/12/comment-promouvoir-son-projet-opensource/"
          >
            Comment promouvoir son projet opensource
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Mon, Jan 02 2017">Mon, Jan 02 2017</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2017/01/02/postgresql-cheatsheet/"
          >
            PostgreSQL cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Fri, Dec 30 2016">Fri, Dec 30 2016</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2016/12/30/sql-cheat-sheet/"
          >
            SQL cheat sheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Thu, Nov 10 2016">Thu, Nov 10 2016</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2016/11/10/make-python-faster/"
          >
            Pypy—Make Python faster!
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sat, Jun 25 2016">Sat, Jun 25 2016</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2016/06/25/redis-cheat-sheet/"
          >
            Redis cheat sheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Wed, Dec 02 2015">Wed, Dec 02 2015</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2015/12/02/log-cheatsheet/"
          >
            Log cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Sun, Aug 02 2015">Sun, Aug 02 2015</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2015/08/02/phpspec-cheatsheet/"
          >
            Phpspec cheatsheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Thu, Mar 12 2015">Thu, Mar 12 2015</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2015/03/12/how-to-install-latest-php-version-on-debian/"
          >
            How to install Latest PHP version on Debian/Linux
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Thu, Feb 05 2015">Thu, Feb 05 2015</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2015/02/05/haskell-extension/"
          >
            A tour of IHaskell extensions
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Tue, Dec 02 2014">Tue, Dec 02 2014</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2015/02/05/haskell-extension/"
          >
            Symfony's cheat sheet
          </a>
        </li>
        <li className="blog-list">
          <time dateTime="Thu, Oct 02 2014">Thu, Oct 02 2014</time>{" "}
          <a
            className="blog-link"
            href="https://mawuen.github.io/2014/10/02/git-cheatsheet/"
          >
            Git cheatsheet
          </a>
        </li>

        {blogsData.map((blog, index) => {
          return <Li key={index}>
            <Time>{blog.dateTime}</Time>
            <span> </span>
            <Anchor href={blog.href} >{blog.blogTitle}</Anchor>
          </Li>;
        })}
      </ul>
    </div>
  );
}



export default Blogs;
